import React, { useState,useEffect,useRef } from 'react';
import '../lib/bootstrap.min.css'
import './Main.css';
import { useParams } from "react-router-dom";

const Test = (props) => {
    
    const [loading,setLoading] = useState(false);


    const getData = () => {
        setLoading(true)
          
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const formdata = new URLSearchParams();
        formdata.append("license_key", "8KNZ-SKND-PUMP-P4JZ");
        formdata.append("hw_code", "52f5b538b50f0edd");

        for (var pair of formdata.entries()) {
            console.log(pair); 
        }

        const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
        };

        fetch("https://vision.net.last40.com/api/app/license/auth", requestOptions)
        .then((response) => response.json())
        .then((result) => console.log(result))
        .catch((error) => console.error(error));
            
        setLoading(false)
    };

    useEffect(() => {
        getData()
    },[]);


  return (<p>Test</p>);
};

export default Test;


